/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProviderValidationStatus = {
    Invalid: 'INVALID',
    Outdated: 'OUTDATED',
    Waiting: 'WAITING',
    Valid: 'VALID'
} as const;
export type ProviderValidationStatus = typeof ProviderValidationStatus[keyof typeof ProviderValidationStatus];


export function instanceOfProviderValidationStatus(value: any): boolean {
    for (const key in ProviderValidationStatus) {
        if (Object.prototype.hasOwnProperty.call(ProviderValidationStatus, key)) {
            // @ts-ignore
            if (ProviderValidationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProviderValidationStatusFromJSON(json: any): ProviderValidationStatus {
    return ProviderValidationStatusFromJSONTyped(json, false);
}

export function ProviderValidationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderValidationStatus {
    return json as ProviderValidationStatus;
}

export function ProviderValidationStatusToJSON(value?: ProviderValidationStatus | null): any {
    return value as any;
}

